<script lang="ts" setup>
withDefaults(
  defineProps<{
    notification?: string | null
  }>(),
  { notification: null }
)
</script>

<template>
  <div v-if="notification" class="flex">
    <div class="w-5">
      <svg fill="none" viewBox="0 0 20 21" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 3.53296C6.15 3.53296 3 6.68296 3 10.533C3 14.383 6.15 17.533 10 17.533C13.85 17.533 17 14.383 17 10.533C17 6.68296 13.85 3.53296 10 3.53296ZM9.45 6.53296H10.55V12.033H9.45V6.53296ZM10 15.033C9.6 15.033 9.25 14.683 9.25 14.283C9.25 13.883 9.6 13.533 10 13.533C10.4 13.533 10.75 13.883 10.75 14.283C10.75 14.683 10.4 15.033 10 15.033Z" fill="#FFB100" />
      </svg>
    </div>

    <span class="ml-1 block text-sm leading-tight text-[#ffb100] lg:max-w-[75%] xl:max-w-[90%]">
      {{ notification }}
    </span>
  </div>
</template>
